module.exports = __webpack_public_path__ + "img/section4BgSvg.c2c4dfca.svg";